import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { connect } from 'react-redux'
import dispatchers from 'reduxModules/hijack/dispatchers'
import selectors from 'reduxModules/hijack/selectors'
import _ from 'lodash'

import withRouterV6 from '../../utils/withRouterV6'
import './styles.css'

export class Hijack extends Component {
  componentDidMount() {
    const { canHijack, hijacking, location, hijack } = this.props
    if (canHijack && _.has(location, 'query.userid')) {
      if (hijacking) this.props.releaseHijacked()
      hijack(location.query.userid)
    }
  }

  componentDidUpdate(prevProps) {
    const { canHijack, hijacking, subscription, location, hijack } = this.props
    const prevUserId = _.get(prevProps, 'location.query.userid')
    const newUserId = _.get(location, 'query.userid')

    if (canHijack && newUserId && newUserId !== prevUserId) {
      if (hijacking) this.props.releaseHijacked()
      hijack(newUserId)
    }

    if (hijacking && hijacking !== prevProps.hijacking)
      if (_.isNumber(subscription)) this.props.loadSubscription(subscription)
  }

  render() {
    const { canHijack, hijacking } = this.props
    return (
      <main id="Hijack" className="wrapper">
        {canHijack && !hijacking && (
          <div className="spinner">
            <div className="double-bounce1" />
            <div className="double-bounce2" />
          </div>
        )}
        {canHijack && !hijacking && (
          <div>
            Gathering user information... You will be redirected to the Home page in a moment.
          </div>
        )}
        {!canHijack && hijacking && (
          <div>
            You are already impersonating a user, release the current user before impersonating a new one.
          </div>
        )}
        {!canHijack && !hijacking && (
          <div>
            You don&apos;t have permissions for this feature.
          </div>
        )}
      </main>
    )
  }
}

Hijack.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      userid: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  hijacking: PropTypes.bool.isRequired,
  canHijack: PropTypes.bool.isRequired,

  // Dispatchers
  hijack: PropTypes.func,
  releaseHijacked: PropTypes.func.isRequired,
  loadSubscription: PropTypes.func.isRequired,
  subscription: PropTypes.oneOfType([
    PropTypes.shape({
      active: PropTypes.bool,
      braintreeId: PropTypes.string,
      free: PropTypes.bool,
      id: PropTypes.number
    }),
    PropTypes.number
  ])
}

Hijack.defaultProps = {
  subscription: null,
  hijack: null
}

export default withRouterV6(connect(selectors, dispatchers)(Hijack))
